module.exports = __webpack_public_path__ + "img/图标6.ad477575.png";